import { useState, useEffect } from 'react';
import axios from 'axios';

// 🎯 كان فيه [30.0444, 31.2357] (القاهرة) متكررة حرفيًا كـ fallback في أكتر
// من ملف (LocationDetails.js وOrganizationDetails.js) - قيمة مش منطقية
// لأي عميل خارج مصر. دلوقتي بتُقرأ من System Settings العامة (GENERAL/
// DEFAULT_LAT/DEFAULT_LNG) اللي الأدمن بيحددها مرة واحدة للنظام ككل، وبترجع
// للقاهرة فقط لو الأدمن لسه مقفلهاش خالص (safety net، مش قيمة نهائية)
const FALLBACK_LAT = 30.0444;
const FALLBACK_LNG = 31.2357;
const GLOBAL_ORG_ID = '__GLOBAL__';

export const useDefaultMapCenter = () => {
  const [center, setCenter] = useState({ lat: FALLBACK_LAT, lng: FALLBACK_LNG, country: '', loaded: false });

  useEffect(() => {
    let mounted = true;
    axios.get(`/api/admin/system-settings?org_id=${GLOBAL_ORG_ID}&app_name=GENERAL`)
      .then((res) => {
        if (!mounted) return;
        const obj = {};
        (res.data || []).forEach((item) => { obj[item.setting_key] = item.setting_value; });
        const lat = parseFloat(obj.DEFAULT_LAT);
        const lng = parseFloat(obj.DEFAULT_LNG);
        setCenter({
          lat: Number.isFinite(lat) ? lat : FALLBACK_LAT,
          lng: Number.isFinite(lng) ? lng : FALLBACK_LNG,
          country: obj.DEFAULT_COUNTRY || '',
          loaded: true,
        });
      })
      .catch(() => { if (mounted) setCenter((prev) => ({ ...prev, loaded: true })); });
    return () => { mounted = false; };
  }, []);

  return center;
};

export default useDefaultMapCenter;
